import { Card, Badge, Button, Group, Text, Stack, ActionIcon, Tooltip } from "@mantine/core";
import { IconBed, IconClock, IconDotsVertical } from "@tabler/icons-react";
import { motion } from "framer-motion";

const RatePlanCard = ({ plan, handleEdit, handleDelete }) => {

  const mealLabels = {
    none: "Aucun repas",
    breakfast: "Petit déjeuner",
    half_board: "Demi pension",
    full_board: "Pension complète"
  };

  return (

    <motion.div whileHover={{ y: -6 }} transition={{ duration: 0.2 }}>

     <Card
        shadow="sm"
        radius="lg"
        p="lg"
        withBorder
        style={{ maxWidth: 320 }}
        className="hover:shadow-md transition-all duration-200"
      >

        <Stack gap="md">

          {/* HEADER */}

          <Group justify="space-between" align="flex-start">

          <Stack gap={4} style={{ flex: 1, minWidth: 0 }}>

            <Text size="xs" c="dimmed">
              Tarif
            </Text>

            <Tooltip label={plan.name}>
              <Text
                fw={600}
                size="lg"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {plan.name}
              </Text>
            </Tooltip>

            <Group gap="xs">
              <IconBed size={16} />
              <Text size="sm" c="dimmed">
                {plan.rooms?.length || 0} chambres
              </Text>
            </Group>

          </Stack>

          <Stack align="flex-end" gap={6}>

            {plan.adjustmentType !== "none" && (
              <Badge variant="light" color="cyan" radius="md">
                {plan.adjustmentType === "percentage"
                  ? `${plan.adjustmentValue}%`
                  : `+${plan.adjustmentValue}€`}
              </Badge>
            )}

            <ActionIcon
              variant="subtle"
              color="gray"
              style={{ opacity: 0.6 }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.6)}
            >
              <IconDotsVertical size={18} />
            </ActionIcon>

          </Stack>

        </Group>

          {/* BADGES */}

          <Group>

            <Badge
              variant="light"
              color="green"
              leftSection={<IconClock size={14} />}
            >
              Annulation {plan.cancellationPolicy?.hoursBeforeArrival}h
            </Badge>

            <Badge variant="light" color="cyan">
              {mealLabels[plan.mealPlan]}
            </Badge>

          </Group>

          {/* ACTIONS */}

          <Group mt="xs">

            <Button
              size="xs"
              radius="md"
              color="green"
              onClick={() => handleEdit(plan)}
            >
              Modifier
            </Button>

            <Button
              size="xs"
              color="red"
              variant="light"
              radius="md"
              onClick={() => handleDelete(plan)}
            >
              Supprimer
            </Button>

          </Group>

        </Stack>

      </Card>

    </motion.div>
  );
};

export default RatePlanCard;